export default "__VITE_ASSET__e73a14c0__"